/**
 * 효과음 프리셋. 전부 WebAudio 합성이며 외부 파일을 쓰지 않는다.
 * 각 프리셋의 설계 의도는 docs/game-design.md 12장에 정리되어 있다.
 */

import { synth } from './Synth';

export const Sfx = {
  swing(): void {
    synth.noise({
      duration: 0.09,
      gain: 0.16,
      filterFreq: 1400,
      endFilterFreq: 420,
      q: 1.6,
    });
  },

  hit(): void {
    synth.tone({ freq: 120, endFreq: 60, type: 'square', duration: 0.11, gain: 0.22 });
    synth.noise({ duration: 0.08, gain: 0.2, filterFreq: 900, endFilterFreq: 200, q: 0.9 });
  },

  crit(): void {
    synth.tone({ freq: 160, endFreq: 70, type: 'square', duration: 0.14, gain: 0.26 });
    synth.noise({ duration: 0.1, gain: 0.24, filterFreq: 1600, endFilterFreq: 260, q: 1.1 });
    synth.sequence([740, 988, 1319], 0.045, { type: 'triangle', gain: 0.16, noteDuration: 0.12 });
  },

  skill(): void {
    synth.noise({ duration: 0.16, gain: 0.18, filterFreq: 2200, endFilterFreq: 300, q: 2.2 });
    synth.sequence([392, 523, 659], 0.05, { type: 'sawtooth', gain: 0.12, noteDuration: 0.16 });
  },

  monsterDie(): void {
    synth.tone({ freq: 420, endFreq: 90, type: 'sawtooth', duration: 0.28, gain: 0.18 });
    synth.noise({ duration: 0.2, gain: 0.14, filterFreq: 700, endFilterFreq: 120, q: 0.8 });
  },

  playerHurt(): void {
    synth.tone({ freq: 220, endFreq: 110, type: 'square', duration: 0.22, gain: 0.2 });
    synth.tone({ freq: 330, endFreq: 140, type: 'triangle', duration: 0.18, gain: 0.12, delay: 0.03 });
  },

  playerDie(): void {
    synth.sequence([392, 330, 262, 196], 0.13, {
      type: 'triangle',
      gain: 0.2,
      noteDuration: 0.34,
    });
  },

  jump(): void {
    synth.tone({ freq: 240, endFreq: 460, type: 'sine', duration: 0.09, gain: 0.14 });
  },

  land(): void {
    synth.noise({ duration: 0.07, gain: 0.12, filterFreq: 320, endFilterFreq: 120, q: 0.7 });
  },

  climb(): void {
    synth.noise({ duration: 0.05, gain: 0.07, filterFreq: 700, endFilterFreq: 400, q: 1.4 });
  },

  pickupItem(): void {
    synth.sequence([880, 1320], 0.055, { type: 'sine', gain: 0.16, noteDuration: 0.14 });
  },

  pickupMeso(): void {
    synth.sequence([1046, 1568], 0.045, { type: 'triangle', gain: 0.14, noteDuration: 0.12 });
  },

  potion(): void {
    synth.tone({ freq: 660, endFreq: 990, type: 'sine', duration: 0.16, gain: 0.14 });
  },

  levelUp(): void {
    synth.sequence([523, 659, 784, 1046, 1319], 0.1, {
      type: 'triangle',
      gain: 0.22,
      noteDuration: 0.4,
    });
    synth.sequence([262, 330, 392], 0.0, { type: 'sine', gain: 0.12, noteDuration: 0.9 });
  },

  portal(): void {
    synth.tone({ freq: 330, endFreq: 880, type: 'sine', duration: 0.34, gain: 0.16 });
    synth.tone({ freq: 495, endFreq: 1320, type: 'sine', duration: 0.3, gain: 0.1, delay: 0.06 });
  },

  deny(): void {
    synth.tone({ freq: 180, endFreq: 140, type: 'square', duration: 0.12, gain: 0.12 });
  },

  uiClick(): void {
    synth.tone({ freq: 720, endFreq: 520, type: 'square', duration: 0.05, gain: 0.08 });
  },

  status(): void {
    synth.tone({ freq: 520, endFreq: 280, type: 'square', duration: 0.09, gain: 0.1 });
    synth.tone({ freq: 240, endFreq: 160, type: 'triangle', duration: 0.12, gain: 0.08, delay: 0.02 });
  },

  mobShot(): void {
    synth.noise({ duration: 0.11, gain: 0.14, filterFreq: 900, endFilterFreq: 280, q: 1.2 });
    synth.tone({ freq: 380, endFreq: 160, type: 'triangle', duration: 0.1, gain: 0.1 });
  },
};
